import { render, staticRenderFns } from "./ClenchFingers2.vue?vue&type=template&id=d0b6562c&"
import script from "./ClenchFingers2.vue?vue&type=script&lang=js&"
export * from "./ClenchFingers2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports